import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React, { useEffect, useState } from "react"; 
import { Doughnut } from "react-chartjs-2";
import axios from "../../api/axios";
import { getArrearsDetails, } from "../../api/endPoints";
import { nbfArrearAmount } from "../../api/restApi";
import { useSelector } from "react-redux";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function Payment() {
  const customerId = useSelector((state) => state.currentUser.name);
  const role = useSelector((state) => state.currentUser.role);
  const [arrear, setArrear] = useState(0);
  const [pieData, setPieData] = useState({
    labels: [],
    datasets: [
      {
        label: "Arrear: ",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      },
    ],
  });
  var dynamicColors = function () {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgb(" + r + "," + g + "," + b + ")";
  };
  const setPie = (data) => {
    let oldData = pieData;
  
    // Filter data based on user role
    if (role === "cs") {
      data = data.filter(element => element.id == customerId);
    }
  
    // Arrange data by arrear amount
    data.sort((a, b) => {
      return b.arrearAmount - a.arrearAmount;
    });
  
    data.forEach((element) => {
      if (element.arrearAmount === 0 || element.arrearAmount === "0") {
        return;
      }
      oldData.labels.push(element.name_urdu);
      oldData.datasets[0].data.push(element.arrearAmount);
      oldData.datasets[0].backgroundColor.push(dynamicColors());
      oldData.datasets[0].borderColor.push(dynamicColors());
    });
    setPieData(oldData);
  };
  
  useEffect(() => {
    const fetchArrear = async () => {
      const response = await axios.get(getArrearsDetails);
      const responseX = await nbfArrearAmount(customerId);
      if(role==="cs"){
        setArrear(responseX.arrearAmount);
      }
      else{
        setArrear(response.data.arrearAmount);
      }
      
      setPie(response.data.paymentData);
    };
    fetchArrear();
  }, []);

  return (
    <div>
      <Stack alignItems="center" spacing={1} marginTop="0rem">
        <Box sx={{ flexGrow: 0 }}>
          <Grid item xs={24} md={6}>
            <Card
              alignItems="start"
              sx={{
                width: "100%",
                marginTop: "0rem",
                "@media (min-width: 300px)": {
                  width: 300, // Set the width to 100% for mobile view
                },
                "@media (min-width: 650px)": {
                  width: 650, // Set the width to 650px for screens wider than 650px
                },
              }}
            >
              <CardContent>
                <Stack alignItems="center">
                  <h2>Arrears: {arrear?.toLocaleString()}</h2>
                </Stack>
                <div>
                  <Doughnut
                    data={pieData}
                    height="300px"
                    width="300px"
                    options={{
                      maintainAspectRatio: false,
                      plugins: {
                        legend: {
                          onClick: (e) => e.stopPropagation(),
                        },
                      },
                    }}
                  />
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Box>
      </Stack>
    </div>
  );
}